import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1875 1238"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#CCE1FF",
  "fill-rule": "evenodd",
  d: "M159.665 380.913c159.04 39.24 197.801-87.712 346.266-51.014 22.999 5.239 106.588 35.903 130.509 124.203S603.6 599.349 593.033 610.33c-107.4 101.616-207.859 5.543-325.779 117.014-72.117 68.051-77.546 198.408 5.77 274.156 40.044 36.33 93.719 56.73 149.225 56.71 55.506-.03 108.299-20.47 146.77-56.84 113.534-107.302 13.831-206.467 120.009-304.335 31.652-24.353 89.559-60.904 172.673-40.397 89.552 22.095 120.205 89.733 131.264 115.554 42.485 137.059-93.669 175.354-48.247 321.938 15.437 49.65 51.405 91.99 100.002 117.7 48.6 25.72 105.85 32.71 159.19 19.44 111.28-27.83 171.99-144.41 143.14-237.507-47.25-152.224-183.55-114.601-226.53-253.354-7.88-28.342-7.84-57.938.12-85.973s23.57-53.577 45.36-74.195c35.04-33.222 94.47-61.23 171.87-45.145 148.65 36.677 140.01-104.159 299.02-64.927 53.89 13.296 112.09 225.969 159.61 200.265 47.53-25.703 59.15-17.691 72.48-67.35 27.75-103.597-52-212.567-153.1-237.511-139.18-34.341-208.17 84.92-342.68 51.731-136.49-33.676-125.59-169.678-384.575-233.576-265.08-62.826-315.347 60.851-453.814 26.688C400.398 177.252 402.142 41.401 260.201 6.38 159.204-18.539 34.488 40.082 6.789 143.491-6.499 193.14 2.136 246.03 30.8 290.546s75.012 77.018 128.865 90.367",
  "clip-rule": "evenodd",
  opacity: ".2"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }